import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TitleBtnComponent } from './title-btn.component';
import { TranslateModule } from '../../translate/translate.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule],
  declarations: [TitleBtnComponent],
  exports: [TitleBtnComponent]
})
export class TitleBtnModule { }
